export { AriaRoles, AriaRole } from './utils/ariaRoles';
export { AriaProperties, AriaPropertiesWithId } from './utils/ariaProperties';
export { generateNewId } from './utils/generateNewId';
export { generateDomPropertiesForAria } from './utils/generateDomPropertiesForAria';
